import { FaArrowRightLong } from 'react-icons/fa6';
import styles from './styles.module.css'

const Card = ({title,description,imageUrl,link}) => {
    return (
        <div className='col-12 col-lg-12 col-xl-4 mt-4'>
            <div className={styles["service"]}>
                <div className="d-flex justify-content-between align-items-center mb-3 mb-lg-5">
                    <div className={`${styles["icon"]} d-flex align-items-center justify-content-center`}>
                        <img 
                            alt={title || ''}
                            src={imageUrl}
                            width={35}
                            height={35}
                        />
                    </div>		
                    <div>
                        <a href={link} className="arrow" title={title || ''}>Learn More <FaArrowRightLong /></a>
                    </div>						
                </div>

                <div className="content my-4">
                    <h3>{title || ''}</h3>
                </div>
                <div>
                    <p>{description || ''}</p>
                </div>					
            </div>
        </div>
    );
};

export default Card;